import { render, staticRenderFns } from "./compWarnList.vue?vue&type=template&id=7d574be7&"
import script from "./compWarnList.vue?vue&type=script&lang=js&"
export * from "./compWarnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports